var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_GB/phone_number/index.js
 ** module id = 406
 ** module chunks = 0
 **/